module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Forms Radio"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forms")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Radio")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h5', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Radio should not have too many options. Otherwise, use the Select component instead.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("optionA")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("optionB")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.radio3),
      callback: function($$v) {
        _vm.radio3 = $$v
      },
      expression: "radio3"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "New York"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Washington"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Los Angeles"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Chicago"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.radio4),
      callback: function($$v) {
        _vm.radio4 = $$v
      },
      expression: "radio4"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "New York"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Washington",
      "disabled": true
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Los Angeles"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Chicago"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.radio5),
      callback: function($$v) {
        _vm.radio5 = $$v
      },
      expression: "radio5"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "New York"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Washington"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Los Angeles"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "Chicago"
    }
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67f2e11f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/form/FormRadio.vue
// module id = 1016
// module chunks = 2